import useFeature from './hooks/useFeature';

export default function Feature({ name, children, render = children }) {
  const hasFeature = useFeature(name);

  if (typeof render === 'function') return render(hasFeature);

  return hasFeature ? render : null;
}
